    // WordPress password error / alert message js-settings
    document.addEventListener("DOMContentLoaded", function () {
    // Check if WordPress password popup id exists
    var checkIdExists = document.getElementById('closeWarningMessage');
    if (checkIdExists) {
        // Hide WordPress (password) error message when click x <= button
        Array.from(document.querySelectorAll('.close-alert-popup'), function (closeAlertPopup) {
            closeAlertPopup.addEventListener("click", function() {
                document.querySelector(".alert-message").classList.add("alert-message-fade-out");
                var delayBackgroundHiding = 300; //0.3 second
                    setTimeout(function() {
                         document.getElementById('deleteWarningMessage').classList.add("hide-default");
                        }, delayBackgroundHiding);
                 });
            });
    }

    else {

    }
    });

     // Hide WordPress (password) error message when clicking somewhere on document but not the popup
    document.addEventListener("DOMContentLoaded", function () {
        document.addEventListener('click', function(e) {
        var alertMessage = document.querySelector('.alert-message'); 
        if (alertMessage) {
        var alertIsClicked = alertMessage.contains(e.target);
        if (alertIsClicked) {
            // Do nothing
          } 
          else {
              // Hide popup
              document.querySelector(".alert-message").classList.add("alert-message-fade-out");
              var delayBackgroundHiding = 300; //0.3 second
                  setTimeout(function() {
                       document.getElementById('deleteWarningMessage').classList.add("hide-default");
                      }, delayBackgroundHiding);
             }
            }
        });
    });

    // This enable search by pressing "enter key"
    document.addEventListener("DOMContentLoaded", function () {
    var inputFilter = document.getElementById("filterInput");
    // Check if archive page filter id exists
    if (inputFilter) {
        inputFilter.addEventListener("keyup", function(event) {
    if (event.keyCode === 13) {
        event.preventDefault();
            document.getElementById("filterContent").click();
        }
        });
    }
    });

    
    // Add login icon on footer in "login section"
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".footer-login-section a").forEach(function(addLoginIcon) {
            var span = document.createElement("span");
            span.setAttribute("class", "iconify");
            span.setAttribute("data-icon", "mdi-login");
            span.style.float = "right";
            span.style.height = "32px";
            addLoginIcon.appendChild(span);
        });
    });


    // Add arrow icon to "read more" links
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".read-more a").forEach(function(addArrow) {
        var span = document.createElement("span");
        span.setAttribute("class", "read-more-arrow");
        span.innerHTML = "&#10230;";
        addArrow.appendChild(span);
        });
    });

    // jQuery code for smooth scroll | When there is more "free time" make this code with pure JavaScript
    (function($) {    
    $( document ).ready(function() {

    $('a[href^="#"]').click(function (e) {
        var headerHeight = 30;
        var target = $(this.hash);
        // Old (broken) check for empty anchor links
        //  if (target.length == 0) target = $('[name="' + this.hash.substr(1) + '"]');

        // If anchor link is empty, don't run the code in this function
        if (target.length == 0)  {
            e.preventDefault();
            return;
        } 
        $('html, body').animate({
            scrollTop: target.offset().top - headerHeight
        }, 1000);
        return false;
    });
});
})( jQuery );


document.addEventListener("DOMContentLoaded", function () {
    const warningMessageClosing = document.getElementById('closeWarningMessage');
    if(warningMessageClosing) {
        const noScrollBody = document.getElementsByTagName( 'body' )[0]; 
        noScrollBody.style.overflow = 'hidden';
        warningMessageClosing.addEventListener('click', function () {
            document.getElementById('deleteWarningMessage').style.display = 'none';
            noScrollBody.style.overflow = 'unset';
          });
    }
    
});

// Add image hover plus elements
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.img-hover-plus img').forEach(function(addPlus) {
    var container = document.createElement('div');
    container.setAttribute('class', 'hover-plus-container');
    var hoverElement = document.createElement('span');
    hoverElement.setAttribute('data-icon', 'mdi-magnify-plus-outline');
    hoverElement.setAttribute('class', 'iconify');
    container.appendChild(hoverElement);
    var parentElement = addPlus.parentNode;
    parentElement.style.position = 'relative';
    parentElement.style.width = 'fit-content';
    parentElement.style.display = 'block';
    parentElement.insertBefore(container, addPlus);
    });
});

// Campaign Template Navigation | Login-button
document.addEventListener("DOMContentLoaded", function () {
    const campaignTemplateLogin = document.getElementById('campaign__Template__login__Button');
    const loginButton = document.querySelector('.nav-campaign-login-button');
    const loginMenu = document.querySelector('.campaign-login-menu');
    if (campaignTemplateLogin) {
        console.log('ID tunnistettu');
        document.addEventListener('click', function(event) {
            const isClicked = campaignTemplateLogin.contains(event.target);
            if (isClicked) {
                console.log('Painiketta ja sen sisältöä klikattu');
                loginButton.classList.add('campaign-menu-is-open');
                loginMenu.classList.add('open-campaign-login');
            } else {
                console.log('Klikattu ohi painikkeesta');
                loginButton.classList.remove('campaign-menu-is-open');
                loginMenu.classList.remove('open-campaign-login');
            }
        });
} 
});


// Dictionary JS-code
document.addEventListener("DOMContentLoaded", function () {

      // Different language responses for js functions
      var checkLang = document.documentElement.lang;

      let loadingText;
      let noContentText;
  
  
      switch (checkLang) {
          case "fi":
              noContentText = 'Tälle kirjaimelle ei löytynyt tietoja';
              break;
          case "en-US":
              noContentText = 'No information found for this letter';
              break;
          case "sv-SE":
              noContentText = 'Ingen information hittades för detta brev';
              break;
      default:
          noContentText = 'No information found for this letter';
      }

    // Get the parent div that will hold the results
    const accountingList = document.querySelector('.accounting-dictionary-list');

    if (accountingList) {
    //Show alphabets in mobile
    const button = document.querySelector('.mobile-accounting-dictionary-list button');
  
    // Get ul list of elements
    const ulList = document.querySelector('.letter-container');
    
    button.addEventListener("click", () => {
      ulList.classList.toggle('visible');
      if (accountingList.style.background) {
        accountingList.style.background = null;
      } else {
        accountingList.style.background = 'linear-gradient(225deg, #3D3D6D, #25254D)';
      
      }
    });

    // If user click some where else than results div => delete current results div
     document.addEventListener("click", (event) => {
          // Clear any existing results from the parent <li> element
          const resultsDiv = document.querySelector('.accounting-dictionary-list .dictionary-results');
        if (resultsDiv) {
            if (!resultsDiv.contains(event.target)) {
                resultsDiv.remove();
                letters.forEach((letter) => {
                    letter.classList.remove('active');
                  });
              } 
        }

      });

    // Get the elements with the "avc-letter" class
    const letters = document.querySelectorAll('.abc-letter');
  
    // Get the loading icon element
    const loadingIcon = document.getElementById('loadingIcon');
  
    // Loop through the letters and add a click event listener to each one
    letters.forEach(letter => {
      letter.addEventListener('click', () => {

        letters.forEach((letter) => {
            letter.classList.remove('active');
          });
  
        // Show the loading icon
        loadingIcon.classList.add('visible');
  
        // Get the letter value
        const cptId = letter.dataset.cpt;
  
        // Clear any existing results from the parent <li> element
        const existingResults = document.querySelector('.accounting-dictionary-list .dictionary-results');
        if (existingResults) {
          existingResults.remove();
        }
  
        // Make a GET request to the WordPress REST API to get the custom post types with the selected letter taxonomy term
        fetch('/wp-json/wp/v2/dictionary?abc-letters=' + cptId)
          .then(response => response.json())
          .then(data => {
  
            // Create a new <div> element to hold the API results
            const resultsDiv = document.createElement('div');
            resultsDiv.classList.add('dictionary-results');
            accountingList.appendChild(resultsDiv);
            letter.classList.add('active');
            // Hide the loading icon
            loadingIcon.classList.remove('visible');
  
            // Check if there is data returned and the length is greater than 0
            if (data && data.length > 0) {
              // Loop through the custom post types and create an element for each one
              data.forEach(dictionary => {
  
                const dictionaryElement = document.createElement('div');
                dictionaryElement.classList.add('dictionary-result');
                dictionaryElement.innerHTML = `<p><a href="${dictionary.link}" title="${dictionary.title.rendered}">${dictionary.title.rendered}</a></p>`;
                resultsDiv.appendChild(dictionaryElement);
              });
            } else {
              // If no data is returned, display an error message
              resultsDiv.innerHTML = '<p style="margin: 0;">' + noContentText + '</p>';
            }
            
            const accountingDictionaryList = document.querySelector('.accounting-dictionary-list');
            const distanceFromTop = accountingDictionaryList.getBoundingClientRect().top + window.pageYOffset;
            const distanceFromLeft = accountingDictionaryList.getBoundingClientRect().left + window.pageXOffset;
            
            const dictionaryResults = accountingList.querySelector('.dictionary-results');
            const liRect = letter.getBoundingClientRect();
            const dictionaryResultsRect = dictionaryResults.getBoundingClientRect();
            const left = liRect.left + window.pageXOffset - dictionaryResultsRect.width / 2 + liRect.width / 2;
            const top = liRect.top + window.pageYOffset + liRect.height - 7;
            const bodyRect = document.body.getBoundingClientRect(); // get the bounding rect of the body tag
            dictionaryResults.style.left = Math.max(0, Math.min(left - distanceFromLeft, bodyRect.width - dictionaryResultsRect.width)) + 'px';
            dictionaryResults.style.top = Math.max(0, Math.min(top - distanceFromTop, bodyRect.height - dictionaryResultsRect.height)) + 'px';
            

          });
      });
    });
    }
  }); 

  // Dictionary JS-code when rezizing window
  window.addEventListener('resize', function() {

    // Get the parent div that will hold the results
    const accountingList = document.querySelector('.accounting-dictionary-list');

    if (accountingList) {

    // Clear any existing results from the parent <li> element
    const checkRezize = document.querySelector('.accounting-dictionary-list .dictionary-results');

    // Get the elements with the "abc-letter" class
    const letters = document.querySelectorAll('.abc-letter');

    const ulList = document.querySelector('.letter-container');

    // Get the current screen width
    var screenWidth = window.innerWidth;

    // Check if the screen width is greater than 750 pixels
    if (screenWidth > 750 && checkRezize) {

        checkRezize.remove();
        letters.forEach((letter) => {
            letter.classList.remove('active');
          });
    }

    if (screenWidth > 750 && accountingList.style.background) {
        accountingList.style.background = null;
      }

      if (screenWidth > 750 && ulList.classList.contains('visible')) {
        ulList.classList.remove('visible');
      }
    }
  });